import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const OCMMSApi = createApi({
  reducerPath: "OCMMSApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["OCMMSApi"],
  endpoints: (build) => ({
    getAllOcmmsCounts: build.mutation({
      query: ({ id }) => ({
        url: `/index.php?VALUE=ocmmscount`,
        method: "POST",
        body: { id: id },
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["OCMMSApi"],
    }),
    getAllOcmmsReports: build.mutation({
      query: (data) => ({
        url: `/ocmms.php?VALUE=report`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["OCMMSApi"],
    }),

    //     getTeacherById: build.query({
    //       query: ({ id }) => ({
    //         url: `/teachers/${id}`,
    //         method: "GET",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       providesTags: ["OCMMSApi"],
    //     }),

    //     editTeacher: build.mutation({
    //       query: ({ id, data }) => ({
    //         url: `/teachers/${id}`,
    //         method: "PUT",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OCMMSApi"],
    //     }),

    //     addTeacher: build.mutation({
    //       query: (data) => ({
    //         url: `/teachers`,
    //         method: "POST",
    //         body: data,
    //         headers: {},
    //       }),
    //       invalidatesTags: ["OCMMSApi"],
    //     }),

    //     deleteTeacher: build.mutation({
    //       query: (id) => ({
    //         url: `/teachers/${id}`,
    //         method: "DELETE",
    //         headers: {
    //           "Content-Type": "application/json; charset=UTF-8",
    //         },
    //       }),
    //       invalidatesTags: ["OCMMSApi"],
    //     }),
  }),
});

export const { useGetAllOcmmsCountsMutation, useGetAllOcmmsReportsMutation } =
  OCMMSApi;
